import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import { WebParameterContext, viewData } from '../../../../model/common';
import { CommonService } from '../../../../service/common.service';
import { BaseCase } from '../../../../app/basecase';
import { GridBaseCase } from '../../grid/grid.base.case';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer/ngx';
import { File } from '@ionic-native/file/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { DomSanitizer } from '@angular/platform-browser';
import { WxjssdkService }from "src/service/wxjssdk.service";
import { MessageclientService } from '../../../../service/messageclient.service';
declare var app;

@Component({
  selector: 'app-mz-notice',
  templateUrl: './mz-notice.component.html',
  styleUrls: ['./mz-notice.component.scss']
})
export class MzNoticeComponent extends GridBaseCase implements OnInit {

  title: string;
  data: any = { head: "",name: "", title: "", date: "", content: "",files:""};
  files:any = [];
  menberInfoList:Array<any> = [];//会员足迹
  idNumber:any;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router:Router,
    private http: HttpCustomerService,
    private com: CommonService,
    private baseService: BaseCase,
    private fileTransfer:FileTransfer,
    private file:File,
    private sanitizer: DomSanitizer,
    private iab:InAppBrowser,
    public wx:WxjssdkService,
    private msg: MessageclientService,
  ) {
    super();
  }
  ngOnInit() {
    const that = this;
    const ConfigName = this.activatedRoute.snapshot.paramMap.get("type");
    const id = this.activatedRoute.snapshot.paramMap.get("id").split('&');
    that.idNumber = this.activatedRoute.snapshot.paramMap.get("id").split('&')[0];
    if (id) {
      let body = new WebParameterContext();
      if (that.element.selectItemList.gridViewConfigName) {
        body.ConfigName = that.element.selectItemList.gridViewConfigName;
      }
      // body.OpType = "GETEDITE";
      // body.ConfigType = "form";

      body.OpType = "query";
      body.ConfigType = "view";
      body.Client.PageName = ConfigName;
      body.Client.Name = ConfigName;
      body.RequestBody = JSON.stringify({ "a_ID": id[0] });
      //console.log(body.RequestBody,'body.RequestBody');
      this.http.post(app.DEFAULTURL, body).then(data => {
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
        if (data.ResponseMessage.Success) {
          // that.dataArrayList = [];
          // data.Status.Datas.forEach(function (item) {
          //   let objfield = {};
          //   that.element.selectItemList.selectItem.forEach((element, index) => {
          //     if (element.bindingField) {
          //       objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
          //     }
          //   });
          //   that.dataArrayList.push(objfield);
          // });
          if(data.Status.RecordCount){
            that.element.selectItemList.selectItem.forEach(item => {
              if (item.bindingField == 'title') {
                // that.baseService.pageTitle = data.Status[item.field];
                that.data.title = data.Status.Datas[0][item.field] || "";
              } else if (item.bindingField == 'date') {
                that.data.date = data.Status.Datas[0][item.field].replace(/-/g,"/") || "";
              } else if (item.bindingField == 'content') {
                that.data.content = that.sanitizer.bypassSecurityTrustHtml(decodeURIComponent((data.Status.Datas[0][item.field] || "").replace(/\+/g," ")));
                console.log(that.data.content);
              } else if (item.bindingField == 'name') {
                that.data.name = data.Status.Datas[0][item.field] || "";
              } else if (item.bindingField == 'files') {
                that.data.files = data.Status.Datas[0][item.field] || "";
                that.ProcessingFiles();
              }
              console.log("内容显示内容显示内容显示")
              console.log(that.data.content);
             
            });
          }else{
            that.data=null;
            that.apiObj['status'] = false;
            that.apiObj['msg'] = "暂无数据";
          }
          //console.log(that.data,'that.data');
        } else {
          console.log(data.ResponseMessage.ErrorMessage);
        }
      }).catch(error => {
        that.apiObj['status'] = false;
        that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
        that.loading = true;
      })
    }

  }


  ProcessingFiles(){
    const that = this;
    that.files = [];
    if(!that.data.files){
      return;
    }
    let filesArr = that.data.files.split(",");
    filesArr.forEach(item=>{
      let _obj = {};
      let reg=/(.*)\.(jpg|bmp|gif|jpeg|png)$/;
      if(reg.test(item)){
        _obj["type"] = "img";
        _obj["name"] = item;
        _obj["url"] = (app.FileUoloadUrl + item).replace(app.ImagePlaceholder,app.SmallImageType);
        that.files.push(_obj);
      }else{
        _obj["type"] = "file";
        _obj["name"] = item;
        _obj["url"] = (app.FileUoloadUrl + item).replace(app.ImagePlaceholder,app.SmallImageType);
        that.files.push(_obj);
      }
      
    })
  }


  imgPreview(item,index) {
    let that = this;
    let url = item.url;
    that.idNumber = item.id;
    
    url = encodeURI(url.trim().replace(app.SmallImageType,app.BigImageType));
    let ImgPreview = {
      imgUrl: [url],
      index: 1
    }
    // localStorage.setItem("ImgPreview",JSON.stringify(ImgPreview));
    // that.router.navigate(["/tabs/contact/ImgPreview"]);
    that.com.Go("/tabs/contact/ImgPreview",{
      ImgPreview: JSON.stringify(ImgPreview)
    });
    // that.router.navigate(["/tabs/contact/ImgPreview"], {
    //   queryParams: { 
    //     ImgPreview: JSON.stringify(ImgPreview)
    //   }
    // });
  }


  fileDownload(url){
    this.iab.create(url);

    // const fileTransfer: FileTransferObject = this.fileTransfer.create();
    // fileTransfer.download(url,this.file.dataDirectory).then(data=>{
    //   console.log(data);
    // })
  }


  // 富文本html 图片放大显示
  imgbig(e){
    const that = this;
    // 判断点击的标签的类型
    console.log(e.target);
    console.log(e,"888")
    let { tagName,src } = e.target;
    console.log(e.target.getAttribute("copytext"));
    // let copecontent:any; // 复制内容
    // copecontent=e.target.getAttribute("copytext");
    // console.log(copecontent);
    if( tagName === "SPAN" && e.target.innerHTML == "这里" && that.data.title.indexOf("无法下班")>-1 ){
      that.com.setHistoryUrl(false);
      that.com.Go("/tabs/contact/PotentialMembersList/"+that.com.getNowDatetime);
    }

    if(tagName === "IMG") {
      //  处理src 赋值图片放大函数
      let ImgPreview = {
        imgUrl: [src],
        index: 0
      }
     
     
      // 跳转会员足迹
    //  if(tagName === "P"  && arrName.find(ut=>ut.name=="mmp")){
     
      console.log(ImgPreview);
      that.com.setHistoryUrl(false);
      that.com.Go("/tabs/contact/ImgPreview/"+that.com.getNowDatetime,{
        ImgPreview: JSON.stringify(ImgPreview)
      });
      // that.router.navigate(["/tabs/contact/ImgPreview/"+that.com.getNowDatetime], {
      //   queryParams: {
      //     ImgPreview: JSON.stringify(ImgPreview)
      //   }
      // });
    }

  if(tagName === "P" && e.target.getAttribute("mmp") == "true" ){
    let attname=e.target.attributes;
// let arrName:any =[];
let sncCode:any;
let Mobile:any;
let items={};
  let copecontent:any=""; // 复制内容
  // arrName.push(attname);
    // arrName.forEach(element => {
        copecontent = attname.copytext.value || attname.copytext.textContent;
        console.log(copecontent);
        console.log(sncCode,Mobile);
        // 复制话术
        try {
          var aux = document.createElement("input"); 
          console.log(aux);
            aux.setAttribute("value", copecontent); 
            document.body.appendChild(aux); 
            aux.select();
            document.execCommand("copy"); 
            document.body.removeChild(aux);
            console.log(aux);
           console.log("打开微信"); 
            that.wx.SetClipboardData(copecontent).then(res=>{
              // that.msg.Alert(JSON.stringify(res));
            
            }).catch(err=>{
              // that.msg.Alert(JSON.stringify(err));
            });
           
         }catch(err){}
        //  跳转会员足迹详情
        let _objcopecontent = {};
        _objcopecontent["SSRCode"] = attname.snccode.value || attname.snccode.textContent;
        _objcopecontent["BabyBirthDay"] = attname.babybirthday.value || attname.babybirthday.textContent;
        _objcopecontent["Imf_Result"] = attname.imf_result.value || attname.imf_result.textContent;
        _objcopecontent["IsAuth"] = /^true$/i.test(attname.isauth.value);
        _objcopecontent["MMP_Joindate"] = attname.mmp_joindate.value || attname.mmp_joindate.textContent;
        _objcopecontent["MMP_Platform"] = attname.mmp_platform.value || attname.mmp_platform.textContent;
        _objcopecontent["MMP_ProductName"] = attname.mmp_productname.value || attname.mmp_productname.textContent;
        _objcopecontent["LoyalMember_Joindate"] = attname.loyalmember_joindate.value || attname.loyalmember_joindate.textContent;
        _objcopecontent["LoyalMember_Platform"] = attname.loyalmember_platform.value || attname.loyalmember_platform.textContent;
        _objcopecontent["LoyalMember_ProductName"] = attname.loyalmember_productname.value || attname.loyalmember_productname.textContent;
        _objcopecontent["Mama_Result"] = attname.mama_result.value || attname.mama_result.textContent;
        _objcopecontent["Mobile"] = attname.mobile.value || attname.mobile.textContent;
        _objcopecontent["NUMBER"] = attname.number.value || attname.number.textContent; //  要是数字
        _objcopecontent["Name"] = attname.name.value || attname.name.textContent;
        _objcopecontent["NewCustomerType"] = attname.newcustomertype.value || attname.newcustomertype.textContent;
        _objcopecontent["Openid"] = attname.openid.value || attname.openid.textContent;
        _objcopecontent["Register_time"] = attname.register_time.value || attname.register_time.textContent;
        _objcopecontent["S3_Result"] = attname.s3_result.value || attname.s3_result.textContent;
        _objcopecontent["S4_Result"] = attname.s4_result.value || attname.s4_result.textContent;
        _objcopecontent["Tepei_Result"] = attname.tepei_result.value || attname.tepei_result.textContent;
        _objcopecontent["WeChatNickName"] = attname.wechatnickname.value || attname.wechatnickname.textContent;
        that.menberInfoList.push(_objcopecontent);
         
    

        let datae:any=_objcopecontent;
      // that.menberInfoList.forEach(function (datae) {
        items = {
          "id":{"value":that.idNumber.value,"text":"id"},
          "sex":{"text":"图标"},
          "name":{"value":datae.Name,"text":"会员名称"},
          "phone":{"value":datae.Mobile,"text":"手机号"},
          "phones":{"value":datae.Mobile,"text":"手机号2"},
          "isAuth":{"value":datae.IsAuth,"text":"是否授权"},
          "jdName":{"text":"阶段"},
          "product":{"text":"购买产品"},
          "birthday":{"value":datae.BabyBirthDay,"text":"宝宝生日"},
          "wechat_id":{"value":datae.Openid,"text":"微信UserID"},
          "createtime":{"value":datae.Register_time,"text":"注册时间"},
          "product_id":{"text":"产品ID"},
          "type1":{"text":"普通会员"},
          "type2":{"text":"店访结果"},
          "type3":{"text":"妈妈粉店访结果"},
          "info1":{"value":datae.Imf_Result,"text":"审核状态"},
          "inf2":{"value":datae.Mama_Result,"text":"S3"},
          "memberstype":{"value":datae.NewCustomerType,"text":"新客类型"},
          "inf4":{"value":datae.S3_Result,"text":"MAM"},
          "inf5":{"value":datae.Tepei_Result,"text":"特配"},
          "inf6":{"value":datae.S4_Result,"text":"四段会员"},
          "wechatnickname":{"value":datae.WeChatNickName,"text":"微信昵称"}
         }
      // })
    // });
    // 加密手机号姓名
    if(items["name"] && items["name"].value){
             
      console.log(items["isAuth"].value,"数值数值");
      items["name"].value=that.com.FormatName(items["name"].value , !items["isAuth"].value);
    }
    if(items["phone"]){
      if(items["phone"].value){
        let phone:string=items["phone"].value;
        items["phone"].value=that.com.PhoneNum(phone.toString(),!items["isAuth"].value);
      }
    }
   
    that.EventLink(items);
  }
 
  }
  // 跳转会员详情接口
  EventLink(item){
    const that=this;
    console.log(that.menberInfoList,"jjjjjjjjjjjjjjjjj")
    // debugger;
    console.log(item);
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
      body.ConfigName="UpdateMemberInfo";
      body.OpType = "edite";
      body.ConfigType = "form";
      body.RowsPerPage = app.RowsPerPage;
      // body.RowsPerPage = 2;
      body.PageNumber = 1;
      body.Client.PageName = "TBNewMemberTypeXML";
      body.Client.ApiType = "Element";
      body.Client.Name = that.element.name;
      body.Client.ClientType = 2;
      let el=that.menberInfoList.find(ut=>ut.Mobile==item.phones.value.toString());
      console.log(el,"zmmzmmzmmzmzmzmzmmzzm&&&&&&&&&&&")
      body.RequestBody=JSON.stringify(el);
         that.msg.Loading("加载中，请稍后...").then(load=>{
          that.http.post(app.DEFAULTURL, body).then(data => {
            // debugger;
            load.dismiss();
            if(data.ResponseMessage.Success)
            {
             item.id.value=data.Status.Datas[0].id;
             item.wechat_id.value=data.Status.Datas[0].Openid;
             console.log(item,"iiiiiiii")
             localStorage.setItem("customerTag",JSON.stringify(item));
             localStorage.setItem("information",JSON.stringify(item));
             that.com.setHistoryUrl(false);
             that.com.Go("/tabs/contact/WCustomerDetail/view/"+item.id.value + "&" + that.com.getNowDatetime);
            }else{
              that.msg.Alert(data.ResponseMessage.ErrorMessage);
            }
           }).catch(err=>{
            load.dismiss();
             that.msg.Alert("请求失败,请联系管理员");
           });
           load.present();
         });
  }

}
